<template>
  <div>
    <div class="ft-16 font-bold mb15">{{ title }}</div>
    <div class="box-item-dasboard p10 mb30">
      <div class="row g-1 align-items-center">
        <div class="col-sm-8 for-land">
          <div class="row g-2 align-items-center mm15">
            <div class="col-2"><img :src="icon" class="img-fluid"></div>
            <div class="col-10">{{ description }}</div>
          </div>
        </div>
        <div class="col-sm-4 for-land">
          <router-link :to="href" class="btn btn-orange w-100">Add New</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardQuickAccess",
  props: ['title', 'description', 'icon', 'href']
}
</script>
